<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-13 09:37:08
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-16 21:22:28
-->
<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-13 09:37:08
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-13 11:29:44
-->
<template>
  <div class="card-items-report">
    <el-card>
      <div class="clearfix" slot="header" v-if="cardData.title">
        <span>{{ cardData.title }}</span>
      </div>
      <div class="list">
        <div :key="index" class="box box-border" v-for="(item, index) in cardData.cardItems">
          <card :item="item" :onClick="toSetting"></card>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
/*
 * title
 * currency
 * number
 * rate
 * tooltip
 * tip
 * {
      title: '今日经营日报',
      cardItems: [
        { title: '成交额', currency: 'USD', number: 1, rate: 0, tooltip: '提示', tip: '' },
        {
          title: '订单量',
          currency: 'USD',
          number: 1,
          rate: 0,
          tooltip: '提示',
          tip: (h) => h('span',['内容', h('a',{attr: {}}, '日报'), '你热']),
        },
        { title: '订单量', currency: 'USD', number: 1, rate: 0, tooltip: '提示', tip: '' },
      ]
    }
 */
import card from './card'
export default {
  name: 'card-items-report',
  props: {
    cardData: {
      default: () => {
        return {
          title: '今日经营日报',
          cardItems: [
            { title: '成交额', currency: 'USD', number: 1, rate: 0, tooltip: '提示', tip: '' },
            {
              title: '订单量',
              currency: 'USD',
              number: 1,
              rate: 0,
              tooltip: '提示',
              tip: h => h('span', ['内容', h('a', { attr: {} }, '日报'), '你热']),
            },
            { title: '订单量', currency: 'USD', number: 1, rate: 0, tooltip: '提示', tip: '' },
          ],
        }
      },
    },
  },
  components: {
    card,
  },
  mounted() {},
  data() {
    return {}
  },
  methods: {
    toSetting() {
      this.$emit('toSetting')
    },
  },
}
</script>
<style lang="scss">
.card-items-report {
  margin-top: 16px;
  .el-card__header {
    overflow: hidden;
    height: 46px;
    line-height: 30px;
    box-sizing: border-box;

    color: #909399;
    border-bottom: 1px solid #e5e9f2;
  }

  .title-info {
    position: relative;
  }
  .icon {
    color: #999;
    font-size: 14px;
    margin-left: 5px;
  }
  .tip {
    margin-top: 4px;
    font-size: 12px;
    color: #999999;
  }
  .el-card__body {
    padding: 23px;
  }
  .list {
    display: flex;
    justify-content: space-between;
    .box-wrap {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 23px 40px 26px 23px;
      border-right: 1px solid #e5e9f2;
      &:last-child {
        border-right: none;
      }
      .box-img {
        width: 58px;
        height: 58px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ecf2ff;
        border-radius: 50%;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
    .box-border {
      margin-right: 40px;
      border-right: 1px solid #e5e9f2;
      &:last-child {
        margin-right: 0;
        border-right: none;
      }
    }
    @media screen and (min-width: 1400px) {
      .box-border {
        margin-right: 64px;
      }
    }
    .box {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      flex: 1;
      .text {
        font-size: 12px;
        color: #8a909d;
        line-height: 1;
      }
      .number {
        font-size: 22px;
        font-weight: bold;
        color: #010517;
        margin: 12px 0 19px;
        line-height: 1;
      }
      .rate {
        color: #f23e55;
        font-size: 14px;
        display: flex;
        line-height: 1;
        align-items: center;
        font-weight: bold;
        i {
          margin-left: 5px;
          line-height: 14px;
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
